import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useScoutConnectionImapForm } from '../../contexts/scoutConnectionImapFormContext'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { closeModal, isProcessing, submitForm } = useScoutConnectionImapForm()

  const handleCloseButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleConnectButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <ButtonsGroup>
      <Button disabled={isProcessing} variant="text" onClick={handleCloseButtonClick}>
        {t('scout.connection.imap.modal.close')}
      </Button>
      <Button disabled={isProcessing} loading={isProcessing} onClick={handleConnectButtonClick} type="submit">
        {t('scout.connection.imap.modal.connect')}
      </Button>
    </ButtonsGroup>
  )
}
